import { useParams } from "react-router-dom";
import CreateEvent from "./CreateEvent";

function EditEvent() {
  const { eventId } = useParams();
  return <CreateEvent eventId={eventId} />;
}

export default EditEvent;
